import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { SlideUpDown } from "../../../services/script";
import { getCall } from "../../../api/post";
import {
  getValueFromLanguageObject,
  loadUserDetailsFromLocalStorage,
} from "../../../store";
import {
  getMerchantInformationUrl,
  getMasterDetailsIdUrl,
  getTenantInfoUrl,
  getCategoriesLastSixUrl,
} from "../../../services";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import { Link } from "react-router-dom";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../../utils/utils";
import {
  checkAuthAndRedirect,
  getCurrentPath,
} from "../../../utils/cartRedirect";
import { debuglogger } from "../../../utils/logger";
import NavBar from "../navbar/navbar";
import LogoImage from "../header/logo";

class MainFooter extends Component {
  state = {
    contactUs: {},
    showErrorMessageModal: false,
    errorMessage: "",
    masterDetailsObj: {},
    merchantPanelType: "",
    categories: [],
  };

  componentDidMount() {
    this.initMasterDetailsId().then(() => {
      const userDetails = loadUserDetailsFromLocalStorage();
      this.setState({ userDetails });
      this.initTenantInfo();
      this.initContactUs();
      this.initCategory();
      var contentwidth = window.innerWidth;
      if (contentwidth < 750) {
        SlideUpDown("footer-title");
      } else {
        var elems = document.querySelectorAll(".footer-title");
        [].forEach.call(elems, function(elemt) {
          let el = elemt.nextElementSibling;
          el.style = "display: block";
        });
      }
    });
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initTenantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const { id } = masterDetailsObj || {};
    if (!id) {
      return;
    }
    const tenantInfoUrl = getTenantInfoUrl(id);
    const tenantInfo = await getCall(tenantInfoUrl, []);
    if (tenantInfo.error) {
      clearLocalStorageReload({ response: tenantInfo });
      this.loadErrorMessageAnimation(tenantInfo.error.message);
    } else {
      if (
        tenantInfo &&
        tenantInfo.length > 0 &&
        tenantInfo[0].text &&
        tenantInfo[0].text.length > 0
      ) {
        const tenantSettings = JSON.parse(tenantInfo[0].text);
        if ("merchantPanelType" in tenantSettings) {
          this.setState({
            merchantPanelType: tenantSettings.merchantPanelType,
          });
        } else {
          this.setState({
            merchantPanelType: "Sufalamtech Pvt Ltd",
          });
        }
      }
    }
  };

  initContactUs = async () => {
    const { masterDetailsObj } = this.state;
    if (masterDetailsObj && masterDetailsObj.id) {
      const contantusUrl = getMerchantInformationUrl(masterDetailsObj);
      const contactUs = await getCall(contantusUrl, []);
      if (contactUs.error) {
        clearLocalStorageReload({ response: contactUs });
        this.loadErrorMessageAnimation(contactUs.error.message);
        if (contactUs.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, "/login");
          return;
        }
      } else {
        this.setState({ contactUs });
      }
    }
  };

  initCategory = async () => {
    const categoryUrl = getCategoriesLastSixUrl(6);
    const categories = await getCall(categoryUrl, []);
    if (categories.error) {
      clearLocalStorageReload({ response: categories });
      this.loadErrorMessageAnimation(categories.error.message);
    } else {
      this.setState({ categories: categories.categories });
    }
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  render() {
    const {
      contactUs,
      showErrorMessageModal,
      errorMessage,
      merchantPanelType,
      categories,
      userDetails,
    } = this.state;

    // Check if we're on the login page
    const isLoginPage = window.location.pathname.includes("/login");

    return (
      <>
        {/* <footer className="footer-light"> */}
        {/* <div className="light-layout">
          <div className="container">
            <section className="small-section border-section border-top-0">
              <div className="row">
                {isOpenStoreIdExist() && <NavBar />}
                {!isOpenStoreIdExist() && userDetails && <NavBar />}
              </div>
            </section>
          </div>
        </div> */}
        {/* <section className="section-b-space light-layout pt-5 pb-5">
          <div className="container">
            <div className="row footer-theme partition-f">
              <div className="col-md-3">
                <div className="footer-contant">
                  <div className="footer-logo">
                    <LogoImage />
                  </div>
                </div>
              </div>
              <div className="col-md-9">
                <div className="sub-title">
                  <div className="footer-title" />
                  <div className="footer-contant">
                    <ul className="contact-list">
                      {contactUs.address1 && (
                        <li
                          onClick={() => {
                            window.open(
                              `https://www.google.com.sa/maps/search/${
                                contactUs.address1
                              },${
                                contactUs.address2 ? contactUs.address2 : ""
                              }?hl=en`
                            );
                          }}
                        >
                          <a href>
                            <i className="fa fa-map-marker" />
                            {contactUs.address1},{contactUs.address2}
                          </a>
                        </li>
                      )}
                      {contactUs.cellnumber && (
                        <li>
                          <a href={`tel:${contactUs.cellnumber}`}>
                            <i className="fa fa-phone" />{" "}
                            {getValueFromLanguageObject("str_call_us")
                              ? getValueFromLanguageObject("str_call_us")
                              : "Call Us"}
                            : {contactUs.cellnumber}
                          </a>
                        </li>
                      )}

                      {contactUs.email && (
                        <li>
                          <a href={`mailto:${contactUs.email}`}>
                            <i className="fa fa-envelope" />{" "}
                            {getValueFromLanguageObject("str_email_address")
                              ? getValueFromLanguageObject("str_email_address")
                              : "Email Address"}{" "}
                            : {contactUs.email}
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <footer
          className="newDesign pb-5 pb-lg-0"
          style={{
            width: "100%",
            ...(isLoginPage && {
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 1000,
            }),
          }}
        >
          <div className="container">
            <div className="row py-5">
              <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
                <div
                  className="footer-logo"
                  style={{ flex: "0 0 auto", marginRight: "120px" }}
                >
                  <img
                    src="/assets/images/logo-white.svg"
                    alt="logo"
                    height="80px"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
                <h4
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    margin: "0 0 10px 0",
                    color: "white",
                  }}
                >
                  INFORMATION
                </h4>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <span
                    className="text-white"
                    onClick={() => {
                      const currentPath = getCurrentPath(this.props);
                      if (checkAuthAndRedirect(this.props, currentPath)) {
                        this.props.history.push("/aboutus");
                      }
                    }}
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "opacity 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                    onMouseLeave={(e) => (e.target.style.opacity = "1")}
                  >
                    About Us
                  </span>
                  <span
                    className="text-white"
                    onClick={() => {
                      const currentPath = getCurrentPath(this.props);
                      if (checkAuthAndRedirect(this.props, currentPath)) {
                        this.props.history.push("/termsandconditions");
                      }
                    }}
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "opacity 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                    onMouseLeave={(e) => (e.target.style.opacity = "1")}
                  >
                    Terms & Conditions
                  </span>
                  <span
                    className="text-white"
                    onClick={() => {
                      const currentPath = getCurrentPath(this.props);
                      if (checkAuthAndRedirect(this.props, currentPath)) {
                        this.props.history.push("/faq");
                      }
                    }}
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "opacity 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                    onMouseLeave={(e) => (e.target.style.opacity = "1")}
                  >
                    FAQ
                  </span>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
                <h4
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    margin: "0 0 10px 0",
                    color: "white",
                  }}
                >
                  CUSTOMER SERVICE
                </h4>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <span
                    className="text-white"
                    onClick={() => {
                      const currentPath = getCurrentPath(this.props);
                      if (checkAuthAndRedirect(this.props, currentPath)) {
                        this.props.history.push("/contactus");
                      }
                    }}
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "opacity 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                    onMouseLeave={(e) => (e.target.style.opacity = "1")}
                  >
                    Contact Us
                  </span>
                  <span
                    className="text-white"
                    onClick={() => {
                      this.props.history.push("/sitemap");
                    }}
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "opacity 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                    onMouseLeave={(e) => (e.target.style.opacity = "1")}
                  >
                    Sitemap
                  </span>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
                <h4
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    margin: "0 0 10px 0",
                    color: "white",
                  }}
                >
                  MY ACCOUNT
                </h4>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <span
                    className="text-white"
                    onClick={() => {
                      const currentPath = getCurrentPath(this.props);
                      if (checkAuthAndRedirect(this.props, currentPath)) {
                        this.props.history.push("/myprofile");
                      }
                    }}
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "opacity 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                    onMouseLeave={(e) => (e.target.style.opacity = "1")}
                  >
                    My Profile
                  </span>
                  <span
                    className="text-white"
                    onClick={() => {
                      const currentPath = getCurrentPath(this.props);
                      if (checkAuthAndRedirect(this.props, currentPath)) {
                        this.props.history.push("/orders");
                      }
                    }}
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "opacity 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                    onMouseLeave={(e) => (e.target.style.opacity = "1")}
                  >
                    Order History
                  </span>
                  <span
                    className="text-white"
                    onClick={() => {
                      const currentPath = getCurrentPath(this.props);
                      if (checkAuthAndRedirect(this.props, currentPath)) {
                        this.props.history.push("/wishlist");
                      }
                    }}
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "opacity 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                    onMouseLeave={(e) => (e.target.style.opacity = "1")}
                  >
                    Wish List
                  </span>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/* </footer> */}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
      </>
    );
  }
}

export default withRouter(MainFooter);
